export const base = (
    eventId = ':event'
) => `events/${eventId}/production-website/artists`;

export const pages = (
    eventId = ':event'
) => `${base(eventId)}/pages`;
